export enum CountryMilestoneDependencyAppliedInApplication {
  GREEN_OS_ONLY = 'GREEN_OS_ONLY',
  DIGIRES_ONLY = 'DIGIRES_ONLY',
  GREEN_OS_AND_DIGIRES = 'GREEN_OS_AND_DIGIRES',
}
export function isAppliedInDigiRES(value: CountryMilestoneDependencyAppliedInApplication) {
  return value === CountryMilestoneDependencyAppliedInApplication.DIGIRES_ONLY
    || value === CountryMilestoneDependencyAppliedInApplication.GREEN_OS_AND_DIGIRES;
}
